import { SxProps } from '@mui/system'

export const tbgSxProps: SxProps = {
  bgcolor: 'background.paper',
  color: 'text.secondary',
  '& button': {
    width: '2.5em',
    '&:first-of-type': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    },
    '&:last-of-type': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
    },
    '&.Mui-selected': {
      bgcolor: 'info.main',
      '& .MuiTypography-root': {
        color: 'background.default',
      },
      '&:hover': {
        bgcolor: 'info.light',
      } 
    },
  },
  borderRadius: '8px',
}
